
const VisitorManagementReducer = (state = {}, action) => {
    switch (action.type) {
        case "getVisitorListSuccess": {
            return Object.assign({}, state, {
                visitorSearchDetails: action.data,
            });
            break;
        }
        case "getVisitorDetailsSuccess": {
            return Object.assign({}, state, {
                visitorDetail: action.data,
            });
            break;
        }
        case "getPhotoSuccess": {
            return Object.assign({}, state, {
                GetPhoto: action.data,
            });
            break;
        }
        case "getVisitorPhotoSuccess": {
            return Object.assign({}, state, {
                GetVisitorPhoto: action.data,
            });
            break;
        }
       case "postAddVisitorSuccess": {
            return Object.assign({}, state, {
                AddVisitor: action.data,
            });
            break;
        }
       case "putUpdateVisitorSuccess": {
            return Object.assign({}, state, {
                UpdateVisitor: action.data,
            });
            break;
        }  
        case "getCrewIdListSuccess": {
            return Object.assign({}, state, {
                CrewIdList: action.data,
            });
            break;
        } 
        case "ShowVisitorId": {
            return Object.assign({}, state, {
                VisitorIdList: action.data,
            });
            break;
        } 
        case "VisitorUserDetails": {
            return Object.assign({}, state, {
                VisitorUserDetails: action.data,
            });
            break;
          }
    default: {
            return state;
        }
    }
};
export default VisitorManagementReducer;
